// JsFromRoutes CacheKey 5d534408d0219b45ecc241df44ae9a73
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  featuredCities: /* #__PURE__ */ definePathHelper('get', '/consumer/autocomplete/featured_cities'),
}
